<div class="position-relative d-flex flex-column m-0 p-0 w-100 h-100">
  <app-navbar-layout></app-navbar-layout>
  <div class="d-flex flex-column flex-grow-1 overflow-auto " style="margin-top: 70px;">
    <app-sidebar-layout></app-sidebar-layout>
    <div id="content-wrapper">
      <router-outlet id="router-outlet"></router-outlet>
    </div>
  </div>
</div>

<button *ngIf="showChat && chatInitialized" mat-raised-button id="ativador-zpro-lg" class="d-none d-lg-block" (click)="toggleZpro()">Peça ajuda de um especialista<span *ngIf="naoLidas > 0" class="zpro-badge" aria-label="Mensagens novas no chat">{{ naoLidas > 9 ? '9+' : naoLidas }}</span></button>
<button *ngIf="showChat && chatInitialized" mat-fab id="ativador-zpro-sm" class="d-none d-sm-block d-lg-none" (click)="toggleZpro()" aria-label="Peça ajuda de um especialista"><i class="fal fa-comment-question"></i><span *ngIf="naoLidas > 0" class="zpro-badge" aria-label="Mensagens novas no chat">{{ naoLidas > 9 ? '9+' : naoLidas }}</span></button>
